webpackJsonp([226020273838829],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PricingPage = function PricingPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "post" },
	    _react2.default.createElement(
	      "h2",
	      { className: "title" },
	      "Pricing"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "entry" },
	      "Bulls Scoring",
	      _react2.default.createElement(
	        "div",
	        { id: "form" },
	        _react2.default.createElement(
	          "label",
	          null,
	          "300 - 349"
	        ),
	        _react2.default.createElement(
	          "label",
	          null,
	          "$5,600.00"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "label",
	          null,
	          "350 - 380"
	        ),
	        _react2.default.createElement(
	          "label",
	          null,
	          "$8,000.00"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "label",
	          null,
	          "381 - 400"
	        ),
	        _react2.default.createElement(
	          "label",
	          null,
	          "$12,000.00"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "label",
	          null,
	          "401 & up"
	        ),
	        _react2.default.createElement(
	          "label",
	          null,
	          "Negotiable"
	        ),
	        _react2.default.createElement("br", null)
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "entry" },
	      "Sheep Hunts",
	      _react2.default.createElement(
	        "div",
	        { id: "form" },
	        _react2.default.createElement(
	          "label",
	          null,
	          "\xA0"
	        ),
	        _react2.default.createElement(
	          "label",
	          null,
	          "$500.00 to $1000.00"
	        ),
	        _react2.default.createElement("br", null)
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "\xA0"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "entry" },
	      "Elk hunts are available mid September through December.",
	      _react2.default.createElement("br", null),
	      "Elk hunts are 3 - 4 days.",
	      _react2.default.createElement("br", null),
	      "Sheep hunts are 1 - 2 days.",
	      _react2.default.createElement("br", null),
	      "Packages include meals, lodging, snacks, all tags and licensing, cleaning and skinning of animal and transport of animal to meat packing plant.",
	      _react2.default.createElement("br", null),
	      "If you don not harvest an animal you don\u2019t pay. You would pay for food and lodging which is $150.00 per day.",
	      _react2.default.createElement("br", null),
	      "Non hunting companion $150.00 per day.",
	      _react2.default.createElement("br", null),
	      "We require a $1000.00 deposit on elk hunts and the balance at the time of harvest. Deposit will be refunded if you cancel 30 days before your hunt.",
	      _react2.default.createElement("br", null),
	      "Not included in package - processing, taxidermy, and tips for guides and staff.",
	      _react2.default.createElement("br", null)
	    )
	  );
	};
	
	exports.default = PricingPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-d01720e0a45722da744a.js